var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC800",
  fillRule: "evenodd",
  d: "m13.728 1.043 11.338 22.728A1.264 1.264 0 0 1 23.94 25.6H1.26a1.264 1.264 0 0 1-1.128-1.827l11.34-22.73c.427-.857 1.827-.857 2.256 0m-1.083 3.476a.05.05 0 0 0-.09 0L3.334 23.003a.05.05 0 0 0 .045.072h18.443a.05.05 0 0 0 .044-.072zM12.6 18.25a1.575 1.575 0 1 1-1.574 1.577c0-.87.705-1.575 1.574-1.575zm.949-7.65a.1.1 0 0 1 .1.1v6.4a.1.1 0 0 1-.1.1H11.65a.1.1 0 0 1-.1-.1v-6.4a.1.1 0 0 1 .1-.1z",
  clipRule: "evenodd"
})));
export default SvgAlert;